module.exports = new __parcel__URL__("neon_gold_mine_level_13.3f1197bf.png").toString();